module.exports = __webpack_public_path__ + "files/2f67f53d6c71d2aa83d3def092a04ab4.svg";